import { render, staticRenderFns } from "./TaskActions.vue?vue&type=template&id=61bd1351"
import script from "./TaskActions.vue?vue&type=script&lang=js"
export * from "./TaskActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports